import ImgAlejandro from "../../assets/images/about/Alejandro.webp";
import ImgEkaterina from "../../assets/images/about/Ekaterina.webp";
import ImgFreddyG from "../../assets/images/about/FreddyG.webp";
import ImgFreddyM from "../../assets/images/about/FreddyM.webp";
import ImgGeorge from "../../assets/images/about/George.webp";
import ImgMihail from "../../assets/images/about/Mihail.webp";
import ImgPaul from "../../assets/images/about/Paul.webp";
import ImgThomas from "../../assets/images/about/Thomas.webp";
import ImgVarun from "../../assets/images/about/Varun.webp";
import ImgVictor from "../../assets/images/about/Victor.webp";


export const TEAM_DATA = [
  {
    id: 0,
    name: "Victor Hugo Gomez",
    position: "Chief Executive Officer",
    shortPosition: "CEO",
    image: ImgVictor,
    twitter: "",
    linkedin: "",
    description:
      "Victor is our company's co-founder and visionary leader, with a distinguished background in fintech, including his role as the former Senior Vice President of Ventures for Deutsche Borse Group. His strategic foresight drives our success and growth.",
    direction: "left",
  },
  {
    id: 1,
    name: "Paul Herrera",
    position: "Chief Enterprise Architect",
    shortPosition: "CEA",
    image: ImgPaul,
    twitter: "",
    linkedin: "",
    description:
      "As a co-founder and architect behind BITA's disruptive technology, Paul stands at the forefront of innovation in the intersection of finance, tech and organizational agility. As we continue to push the boundaries of what's possible in index technology, Paul's vision and polymathic knowledge ensure that BITA remains delivering solutions that exceed the expectations of the financial sector.",
    direction: "center",
  },
  {
    id: 2,
    name: "George Kuznetsov",
    position: "Chief Operating Officer",
    shortPosition: "COO",
    image: ImgGeorge,
    twitter: "",
    linkedin: "",
    description:
      "George's rich experience spanning data analytics, financial services, and strategic consulting fortifies his role as our Chief Operations Officer. His dynamic, customer-centric leadership is central to our operational excellence.",
    direction: "right",
  },
  {
    id: 3,
    name: "Varun Jain",
    position: "Chief Revenue Officer",
    shortPosition: "CRO",
    image: ImgVarun,
    twitter: "",
    linkedin: "",
    description:
      "Varun brings nearly two decades of experience across banking, trading, and fintech. Prior to BITA, he led global sales at MerQube and helped shape advanced index strategies. He previously held senior trading roles at Deutsche Bank, Tradelink, and Cygnus Capital. His leadership blends commercial strategy with deep expertise in ETFs, indexing, and multi-asset markets.",
    direction: "left",
  },
  {
    id: 4,
    name: "Alejandro Moreau",
    position: "Chief Technology Officer",
    shortPosition: "CTO",
    image: ImgAlejandro,
    twitter: "",
    linkedin: "",
    description:
      "With extensive experience in software consulting, development, and architecture, a knack for critical systems, and a passion for perfection, Alejandro is a seasoned technology leader. His innovative approach, coupled with his project leadership and mentoring, sets him apart as a remarkable technology professional.",
    direction: "center",
  },
  {
    id: 5,
    name: "Ekaterina Eshieva",
    position: "SVP - Compliance Lead",
    shortPosition: "SVP-CL",
    image: ImgEkaterina,
    twitter: "",
    linkedin: "",
    description:
      "Ekaterina is a dedicated professional who serves as the Senior Vice President (SVP)-Compliance Lead at BITA. She is a Russian-qualified lawyer with a Master’s degree in Finance and Law (Goethe University) and more than five years of legal experience. As one of the founding team members, Ekaterina has been an integral part of the company's growth and success.",
    direction: "right",
  },
  {
    id: 6,
    name: "Thomas Lee",
    position: "Head of Business Development - Americas",
    shortPosition: "HBD-A",
    image: ImgThomas,
    twitter: "",
    linkedin: "",
    description:
      "Thomas, our Global Head of Client Solutions & Business Development, brings a client-centric approach and a solutions-driven mindset to our team. He joined us in 2022 following a successful nine-year tenure at JPMorgan, where he held management roles in sales and product leadership. Prior to that, he built his career at New York Life Investments.",
    direction: "left",
  },
  {
    id: 8,
    name: "Mihail Minchev",
    position: "Head of Product Development",
    shortPosition: "TL",
    image: ImgMihail,
    twitter: "",
    linkedin: "",
    description:"With over a decade of experience in the indexing industry, Mihail has held roles at Stoxx, IHS Markt and S&P DowJones Indices, and contributed to every aspect of the indexing value chain. His comprehensive business and technical expertise covers all asset classes and spreads over Research, Development and Operational Management of indices and calculation infrastructure. Passionate about advancing the field of indexing, Mihail combines an analytical mindset and a dedication to quality with a strong problem-solving orientation.",
    direction: "right",
  },  
  {
    id: 11,
    name: "Freddy González",
    position: "Manager - Index Operations",
    shortPosition: "M-IO",
    image: ImgFreddyG,
    twitter: "",
    linkedin: "",
    description:
      "Economist with postgraduate studies in economic sciences, business management, and entrepreneurship. He has worked in research and financial planning, risk management of investment portfolios, and operations management consulting in different economic sectors. Member of BITA since 2019, he helped create BITA’s Thematic R&D Team. Currently, he is the Manager of Index Operations. His vision always prioritizes the learning and creation of high-performance work teams, which generate added value that positively impacts the organization.",
    direction: "left",
},
  {
    id: 12,
    name: "Freddy Manrique",
    position: "IT Infrastructure Lead",
    shortPosition: "ITIL",
    image: ImgFreddyM,
    twitter: "",
    linkedin: "",
    description:
      "Freddy's passion for computer engineering has driven him to excel in his field over the last 7 years. He has developed several applications based on microservices and implemented state-of-the-art methodologies for software development. Freddy is a pro at developing, maintaining and deploying mission-critical systems on Amazon Web Services. His enthusiasm for the DevOps and SRE culture drives BITA's Cloud Infrastructure Team.",
    direction: "right",
  },
];
